"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var remark_1 = __importDefault(require("remark"));
var remark_react_1 = __importDefault(require("remark-react"));
var github_json_1 = __importDefault(require("hast-util-sanitize/lib/github.json"));
var autoTelLink_1 = __importDefault(require("./autoTelLink"));
var sanitize = __assign({}, github_json_1.default);
sanitize.protocols.href.push('tel');
function generateLinkProps(href) {
    var rel = 'noopener';
    if (!href.startsWith('tel:') && !href.startsWith('mailto:')) {
        return { href: href, rel: rel, target: '_blank' };
    }
    return { href: href, rel: rel };
}
exports.renderMarkdown = function (text) {
    var Link = function (_a) {
        var children = _a.children, _b = _a.href, href = _b === void 0 ? '' : _b;
        return react_1.default.createElement("a", __assign({}, generateLinkProps(href)), children);
    };
    return (react_1.default.createElement("div", { className: "md" }, remark_1.default()
        .use(autoTelLink_1.default)
        .use(remark_react_1.default, {
        sanitize: sanitize,
        remarkReactComponents: {
            a: Link
        }
    })
        .processSync(text).result));
};
//# sourceMappingURL=renderMarkdown.js.map